module.exports = __webpack_public_path__ + "static/img/third13.d00e49ee.png";